import type { Phone } from "@/store/v2/currentUser/selectors";

export const PHONE_DEFAULT_VALUE: Phone = {
  code: "+1",
  iso: "US",
  number: "",
} as const;
